const easings = {
  linear(t) {
    return t;
  },
  easeInQuad(t) {
    return t * t;
  },
  easeOutQuad(t) {
    return t * (2 - t);
  },
  easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  },
  easeInCubic(t) {
    return t * t * t;
  },
  easeOutCubic(t) {
    return --t * t * t + 1;
  },
  easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  },
  easeInQuart(t) {
    return t * t * t * t;
  },
  easeOutQuart(t) {
    return 1 - --t * t * t * t;
  },
  easeInOutQuart(t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
  },
  easeInQuint(t) {
    return t * t * t * t * t;
  },
  easeOutQuint(t) {
    return 1 + --t * t * t * t * t;
  },
  easeInOutQuint(t) {
    return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
  }
};

//https://pawelgrzybek.com/page-scroll-in-vanilla-javascript/
const scrollIt = (destination, duration = 200, easing = 'linear', callback) => {
  const start = window.pageYOffset;
  const startTime =
    'now' in window.performance ? performance.now() : new Date().getTime();

  const documentHeight = Math.max(
    document.body.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.clientHeight,
    document.documentElement.scrollHeight,
    document.documentElement.offsetHeight
  );
  const windowHeight =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.getElementsByTagName('body')[0].clientHeight;
  const destinationOffset =
    typeof destination === 'number' ? destination : destination.offsetTop;
  const destinationOffsetToScroll = Math.round(
    documentHeight - destinationOffset < windowHeight
      ? documentHeight - windowHeight
      : destinationOffset
  );

  if ('requestAnimationFrame' in window === false) {
    window.scroll(0, destinationOffsetToScroll);
    if (callback) {
      callback();
    }
    return;
  }

  const scroll = () => {
    const now =
      'now' in window.performance ? performance.now() : new Date().getTime();
    const time = Math.min(1, (now - startTime) / duration);
    const timeFunction = easings[easing](time);
    window.scroll(
      0,
      Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start)
    );
    if (Math.ceil(window.pageYOffset) === destinationOffsetToScroll) {
      if (callback) {
        callback();
      }
      return;
    }

    requestAnimationFrame(scroll);
  };

  scroll();
};

const scrollInElement = (destination, parent, margin = 0) => {
  const destinationOffset =
    typeof destination === 'number' ? destination : destination.offsetTop;
  parent.scrollTop = destinationOffset - parent.offsetTop + margin;
};

const animateProgress = (
  updateLoader,
  onFinish,
  offset = 0,
  destination = 100,
  duration = 1200,
  easing = 'linear',
  delay = 0
) => {
  const start = offset;
  const startTime = new Date().getTime();
  const slide = () => {
    const now = new Date().getTime(),
      time = Math.min(1, (now - startTime) / duration),
      timeFunction = easings[easing](time),
      currentProgress = timeFunction * (destination - start) + start,
      lock = localStorage.getItem('offersLock');
    updateLoader(currentProgress);
    if (parseInt(lock) > startTime || currentProgress >= destination) {
      if (onFinish) {
        onFinish();
      }
      return;
    }
    requestAnimationFrame(slide);
  };

  setTimeout(() => {
    slide();
  }, delay);
};

export { scrollIt, scrollInElement, animateProgress };



// WEBPACK FOOTER //
// ./app/javascript/services/animate.js